module.exports = __webpack_public_path__ + "static/img/game-boy-select-pc.879561e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/game-boy-select-pc.png
// module id = js9m
// module chunks = 1